import { render, staticRenderFns } from "./InventarioTabContent.vue?vue&type=template&id=384d5f84"
import script from "./InventarioTabContent.vue?vue&type=script&lang=js"
export * from "./InventarioTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports